import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { type ChatSidebarSlice, createChatSidebarSlice } from './slices/createChatSidebarSlice';

export type ChatSidebarState = ChatSidebarSlice;

export const useChatSidebarStore = create<ChatSidebarState>()(
  persist(
    (...args) => ({
      ...createChatSidebarSlice({ open: true })(...args),
    }),
    {
      name: 'zustand/ag-ui-chat/sidebar',
      partialize: (state) => ({
        open: state.open,
      }),
      version: 1,
    },
  ),
);

// Convenience hooks for common use cases
export const useChatSidebarOpen = () => useChatSidebarStore((state) => state.open);
export const useChatSidebarToggle = () => useChatSidebarStore((state) => state.toggleOpen);
export const useChatSidebarSetOpen = () => useChatSidebarStore((state) => state.setOpen);
